export function useGetConfigurationsUrls() {
  const baseConfigurationUrl = '/configurations'

  return {
    agents: () => `${baseConfigurationUrl}/agents`,
    base: () => baseConfigurationUrl,
    clusters: () => `${baseConfigurationUrl}/clusters`,
    manageCluster: (clusterId: string) =>
      `${baseConfigurationUrl}/clusters/manage/${clusterId}`,
    privateNetworkIntegrations: () =>
      `${baseConfigurationUrl}/private-network-integrations`
  }
}
